import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const MonitorCasePerformanceInfo = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      The test case steps performance chart shows
      the runtime data of each test case steps in a
      run, allowing you to compare runs and observe trends.
    </Color>
  </Paragraph>

export default MonitorCasePerformanceInfo
